import React from 'react';
import { Container } from '../../components';

import './Home.css';

function Home() {
  return (
    <div className='homepage'>
      <Container />
    </div>
  );
}

export default Home;
